import { To, Navigate, useLocation } from 'react-router-dom';

export default function useCheckIfMatchThenNavigate(match: boolean, to: To) {
  const location = useLocation();
  if (match) {
    return <Navigate to={to} state={location?.state} />;
  }
}
